import { render } from "./ImportColisPage.vue?vue&type=template&id=88aa3f4e&ts=true"
import script from "./ImportColisPage.vue?vue&type=script&lang=ts"
export * from "./ImportColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__